export default __webpack_public_path__ + "static/media/Humidity.0ac52fc7.svg";